<template>
  <v-overlay :value="visible" z-index="9999" opacity="0.85" color="#1a1a2e">
    <div class="maintenance-overlay d-flex flex-column align-center justify-center text-center pa-6">
      <v-icon size="80" color="amber lighten-1" class="mb-4">mdi-wrench-clock</v-icon>
      <h1 class="white--text text-h4 font-weight-bold mb-3">
        Mantenimiento en curso
      </h1>
      <p class="white--text text-body-1 mb-6" style="max-width: 480px;">
        {{ message }}
      </p>
      <v-progress-circular indeterminate color="amber lighten-1" size="36" />
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: 'MaintenanceOverlay',
  props: {
    visible: { type: Boolean, default: false },
    message: { type: String, default: 'Estamos realizando tareas de mantenimiento. Por favor, espere unos minutos.' },
  },
}
</script>
